/**
 * @Author: luoob
 * @Date: 2021-10-28 21:23:03
 * @Last Modified by: luoob
 * @Last Modified time: 2021-10-28 21:23:12
 * @Instruduction: 在线协助状态
 */

import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { OnlineService } from '@/services'
import store from '@/store'
 
export interface OnlineState {
    satisfactions: any[]            // 协助满意度
    orderStates: any[]              // 协助状态
 }
 
 @Module({ dynamic: true, store, name: 'online' })
class Online extends VuexModule implements OnlineState {
    public orderStates: any[] = []
    public satisfactions: any[] = []
 
    @Mutation
    SET_ORDER_STATES(states: any[]) {
        this.orderStates = states
    }
    @Mutation
    SET_SATISFACTIONS(items: any[]) {
        this.satisfactions = items
    }
 
    @Action
    async getOrderStates() {
        // 获取协助状态
        if (this.orderStates.length) return
        const result = await OnlineService.getOrderStatus({})
        if (result.status === 200) {
            this.SET_ORDER_STATES(result.data)
        }
    }

    @Action
    async getSatisfactions() {
        // 获取协助满意度
        if (this.satisfactions.length) return
        const result = await OnlineService.getSurveySatisfaction({})
        if (result.status === 200) {
            this.SET_SATISFACTIONS(result.data)
        }
    }
 }
 
export const OnlineModule = getModule(Online)
 